import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section id="category-nav" className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
            电影分类
          </h2>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 cursor-pointer whitespace-nowrap transition-colors"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100/80 border border-background-200/60 cursor-pointer hover:border-primary-500/40 hover:bg-background-200/50 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-primary-500 text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-50 whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}